/* eslint-disable */
import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { isLogIn } from '../Auth'
import AdminNav from './AdminNav'

const  Private=()=> {

   const name="";

//    let loggedIn=true
  
    if( isLogIn()){
        //  name=localStorage.getItem("data").user.firstname;
console.log("i am in private true")
        // old: return <Outlet/>
        // new: admin menu on top of every admin page, then the page itself
        return <><AdminNav/><Outlet/></>
    }
    else{
        console.log("i am in private false")
        return <Navigate to={"/login"}/>
    }
 
}

export default Private
